import React, { useMemo } from 'react'
import _ from 'lodash'
import { useSelector } from 'react-redux'
import BoardCard from 'routes/Board/Card'
import { useBoardContext } from 'dataProviders/Board'
import { ModalBoardContext } from 'components/Modal'
import KanBoIcon from 'components/KanBoIcon'
import styled from 'styled-components'
import { useCardProvider } from 'components/KanBoProvider'
import { FormattedMessage } from 'components/Intl'

const TypedBoardCard: any = BoardCard

const BoardIcon = styled(KanBoIcon)`
  font-size: 16px;
  margin-right: 0.25em;
`

const IsClosedLabel = styled.span`
  margin-left: .25em;

  & > :first-child {
    font-size: 16px;
    margin-right: .25em;
  }
`

const SmartCard = React.forwardRef<any, any>(({
  id,
  component: Component = TypedBoardCard,
  ...props
}, ref) => {
  const boardContext = useBoardContext()

  const cardProps = useSelector(state => state['view-board'].cards[id])

  const cardIds = useMemo(() => !cardProps?.isBusy ? [id] : [], [id, cardProps?.isBusy])

  useCardProvider(cardIds)

  const isBoardReady = useSelector(state => (cardProps && !cardProps.isBusy) && cardProps?.boardId && state['view-board'].view[cardProps.boardId]?.isLoaded)

  const isInCurrentBoardContext = useMemo(() =>
    isBoardReady && cardProps?.boardId === boardContext.id
  , [isBoardReady, cardProps?.boardId, boardContext.id])

  const boardName = useSelector(state => state['view-board'].view[cardProps?.boardId]?.name)
  const isBoardClosed = useSelector(state => state['view-board'].view[cardProps?.boardId]?.isClosed)

  return isBoardReady ? (
    <ModalBoardContext boardId={cardProps?.boardId}>
      <Component
        {...props}
        ref={ref}
        id={id}
        footer={
          !isInCurrentBoardContext ? (
            <span>
              <BoardIcon name='kanbo-16-external-card1' />
              {boardName}
              {isBoardClosed &&
                <IsClosedLabel>
                  ( <KanBoIcon name='kanbo-16-closed' /><FormattedMessage id='BOARD_TILE_IS_CLOSED' /> )
                </IsClosedLabel>
              }
            </span>
          ) : undefined
        }
      />
    </ModalBoardContext>
  ) : (
    cardProps?.noAccess ? (
      <Component ref={ref} id={id} noAccess {...props} />
    ) : (
      <Component ref={ref} isBusy {...props} />
    )
  )
})

export default SmartCard
